import request from 'superagent';
import BrowserLocationHelper from '../utils/browser_location_helper';

export default class FacebookConnectService {
    static startOauthRequest(token, redirect_or_callback) {
        return request.post("/it/user/oauth_sessions")
            .send({token: token, provider: 'facebook'})
            .set('Accept', 'application/json')
            .end(function (error, res) {
                if (typeof redirect_or_callback === 'function') {
                    redirect_or_callback(error, res);
                } else if (typeof redirect_or_callback === 'string') {
                    BrowserLocationHelper.ChangeURL(redirect_or_callback);
                }
                else {
                }
            });
    }
}
